// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel, HttpExtenstionsModel } from '../../_base/crud';
// State
import { SalesTeamsState } from '../_reducers/sales-team.reducers';
import { each } from 'lodash-es';
import { SalesTeam } from '../_models/sales-team.model';

export const selectSalesTeamsState = createFeatureSelector<SalesTeamsState>('salesTeams');

export const selectSalesTeamById = (salesTeamId: number) =>
  createSelector(selectSalesTeamsState, (salesTeamsState) => salesTeamsState.entities[salesTeamId]);

export const selectSalesTeamsPageLoading = createSelector(
  selectSalesTeamsState,
  (salesTeamsState) => {
    return salesTeamsState.listLoading;
  },
);

export const selectSalesTeamsActionLoading = createSelector(
  selectSalesTeamsState,
  (salesTeamsState) => salesTeamsState.actionsloading,
);

export const selectLastCreatedSalesTeamId = createSelector(
  selectSalesTeamsState,
  (salesTeamsState) => salesTeamsState.lastCreatedSalesTeamId,
);

export const selectSalesTeamsPageLastQuery = createSelector(
  selectSalesTeamsState,
  (salesTeamsState) => salesTeamsState.lastQuery,
);
export const selectErrorState = createSelector(
  selectSalesTeamsState,
  (salesTeamsState) => salesTeamsState.error,
);
export const selectSalesTeamsInStore = createSelector(selectSalesTeamsState, (salesTeamsState) => {
  const items: SalesTeam[] = [];
  each(salesTeamsState.entities, (element) => {
    items.push(element);
  });
  const httpExtension = new HttpExtenstionsModel();
  const result: SalesTeam[] = httpExtension.sortArray(
    items,
    salesTeamsState.lastQuery.sortField,
    salesTeamsState.lastQuery.sortOrder,
  );
  return new QueryResultsModel(result, salesTeamsState.totalCount);
});

export const selectSalesTeamsShowInitWaitingMessage = createSelector(
  selectSalesTeamsState,
  (salesTeamsState) => salesTeamsState.showInitWaitingMessage,
);

export const selectHasSalesTeamsInStore = createSelector(selectSalesTeamsState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
